export default "__VITE_ASSET__$l7hfkWe__"